/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/

/**
 * Internationalization (i18n) configuration using i18next library.
 * Provides multi-language support for the medical record system application.
 * 
 * Supported Languages:
 * - English (en) - Default/fallback language
 * - Spanish (es)
 * - French (fr)
 * - Italian (it)
 * - Portuguese (pt)
 * - Chinese (zh)
 * 
 * Features:
 * - Browser language detection for automatic language selection
 * - HTTP backend for lazy-loading translations
 * - React integration via react-i18next
 * - Translation interpolation without HTML escaping (handled by React)
 * 
 * Usage:
 * Import this file in the application entry point to initialize i18n.
 * Use `useTranslation()` hook or `t()` function in components for translations.
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslations from ".//languages/en/translation.json";
import esTranslations from ".//languages/es/translation.json";
import frTranslations from ".//languages/fr/translation.json";
import itTranslations from ".//languages/it/translation.json";
import ptTranslations from ".//languages/pt/translation.json";
import zhTranslations from ".//languages/zh/translation.json";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

/**
 * Initialize i18next with configuration:
 * - Backend: Enables HTTP backend for loading translation files
 * - LanguageDetector: Auto-detects user's preferred language from browser settings
 * - initReactI18next: Integrates i18next with React components
 * - Resources: Pre-loaded translation JSON files for all supported languages
 * - fallbackLng: Falls back to English if requested language is unavailable
 * - debug: Enables detailed logging for development (should be disabled in production)
 * - lng: Sets English as the default language
 * - interpolation.escapeValue: Disabled as React handles XSS protection automatically
 */
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      es: {
        translation: esTranslations,
      },
      fr: {
        translation: frTranslations,
      },
      it: {
        translation: itTranslations,
      },
      pt: {
        translation: ptTranslations,
      },
      zh: {
        translation: zhTranslations,
      },
    },
    fallbackLng: "en",
    debug: true,
    lng: "en", // default language
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;

